import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  MenuItem,
  Divider,
} from "@mui/material";
import guideGenerator from "./html resourses/guideGenerator";
import manifestGenerator from "./html resourses/manifestGen";
import inkjetticketGenerator from "./html resourses/invoiceGen";
import Swal from "sweetalert2";

const claseBultosOptions = [
  { value: "CS", label: "CS Cajas" },
  { value: "BS", label: "BS Bolsas" },
  { value: "PTS", label: "PTS Paquetes" },
  { value: "U", label: "U Unidades" },
  { value: "SA", label: "SA Sacos" },
  { value: "RO", label: "RO Rollos" },
];

const ElaboracionTransito = () => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [formattedDate, setFormattedDate] = useState("");
  const [open, setOpen] = useState(false);

  const handlePrintGuide = (data) => {
    const completeData = { ...data, fechaExpedicionFormateada: formattedDate };
    // 1. Obtenemos el HTML sin abrir ventana
    const guideHtml = guideGenerator(completeData);

    // 2. Abrimos la ventana y metemos el HTML
    const printWindow = window.open("", "_blank");
    printWindow.document.write(guideHtml);
    printWindow.document.close();

    // 3. Forzamos la impresión un poco después
    setTimeout(() => printWindow.print(), 1500);
  };

  const handlePrintManifest = (data) => {
    const completeData = { ...data, fechaExpedicionFormateada: formattedDate };
    const manifestHtml = manifestGenerator(completeData);

    const printWindow = window.open("", "_blank");
    printWindow.document.write(manifestHtml);
    printWindow.document.close();

    setTimeout(() => printWindow.print(), 1500);
  };

  const handlePrintInkjet = (data) => {
    const completeData = { ...data, fechaExpedicionFormateada: formattedDate };
    const inkjetHtml = inkjetticketGenerator(completeData);

    const printWindow = window.open("", "_blank");
    printWindow.document.write(inkjetHtml);
    printWindow.document.close();

    setTimeout(() => printWindow.print(), 1500);
  };

  const handleSendAllAsPdf = async (data) => {
    try {
      const { value: userEmail } = await Swal.fire({
        title: "Enviar PDF por correo",
        text: "Ingresa la dirección de destino:",
        input: "email",
        inputPlaceholder: "ejemplo@dominio.com",
        showCancelButton: true,
        confirmButtonText: "Enviar",
        cancelButtonText: "Cancelar",
      });

      if (!userEmail) return;

      // Mostrar alerta de cargando
      Swal.fire({
        title: "Enviando...",
        text: "Por favor espera mientras generamos y enviamos los PDFs.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const completeData = {
        ...data,
        fechaExpedicionFormateada: formattedDate,
      };

      const guideHtml = guideGenerator(completeData);
      const manifestHtml = manifestGenerator(completeData);
      const inkjetHtml = inkjetticketGenerator(completeData);

      const htmlPayload = [
        { nombre: "guia-transito.pdf", html: guideHtml },
        { nombre: "manifiesto-carga.pdf", html: manifestHtml },
        { nombre: "carta-porte.pdf", html: inkjetHtml },
      ];

      const formData = new FormData();
      formData.append("destinatario", userEmail);
      formData.append("htmls", JSON.stringify(htmlPayload));

      const response = await fetch(
        "https://api.globaladvanceddata.com/pdf-html",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
          credentials: "include",
        }
      );

      Swal.close(); // Cierra el spinner

      if (response.ok) {
        Swal.fire(
          "¡Enviado!",
          "Se enviaron los 3 PDFs correctamente.",
          "success"
        );
      } else {
        Swal.fire(
          "Enviado (con aviso)",
          "Los PDFs fueron enviados, pero el servidor respondió con una advertencia.",
          "warning"
        );
      }
    } catch (error) {
      console.error("Error al enviar PDF:", error);
      Swal.close(); // Asegúrate de cerrar el spinner en caso de error

      if (
        error.message.includes("NetworkError") ||
        error.message.includes("Failed to fetch") ||
        error.message.includes("TypeError: Failed to fetch")
      ) {
        Swal.fire(
          "¡Enviado!",
          "Se enviaron los 3 PDFs correctamente.",
          "success"
        );
      } else {
        Swal.fire(
          "Error",
          "Hubo un error inesperado al generar o enviar los PDFs.",
          "error"
        );
      }
    }
  };

  const onSubmit = (formData) => {};

  const onSubmitGuide = (data) => {
    const completeData = { ...data, fechaExpedicionFormateada: formattedDate };
    guideGenerator(completeData);
  };

  const onSubmitManifest = (data) => {
    const completeData = { ...data, fechaExpedicionFormateada: formattedDate };
    manifestGenerator(completeData);
  };

  const onSubmitInkjet = (data) => {
    const completeData = { ...data, fechaExpedicionFormateada: formattedDate };
    inkjetticketGenerator(completeData);
  };

  const formatDate = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  const meses = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ];
  return `${parseInt(day)} de ${meses[parseInt(month) - 1]} de ${year}`;
};

  const handleDateChange = (date) => {
    if (date) {
      setFormattedDate(formatDate(date));
    } else {
      setFormattedDate("");
    }
  };
  return (
    <Box>
      <Box style={{ padding: "10px" }}>
        <Typography
          variant="h4"
          gutterBottom
          style={{
            padding: "10px",
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "100%", // Evita que el texto se desborde
            textAlign: "center",
          }}
        >
          ELABORACIÓN DE DOCUMENTOS DE TRÁNSITO
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Controller
                name="transportista"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Transportista es obligatorio",
                  maxLength: {
                    value: 45,
                    message: "Máximo 45 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Transportista"
                    fullWidth
                    error={!!errors.transportista}
                    helperText={errors.transportista?.message}
                    inputProps={{ maxLength: 45 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="codigoTransportista"
                control={control}
                defaultValue=""
                rules={{
                  required: "El codigo transportista es obligatorio",
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Codigo Transportista"
                    fullWidth
                    error={!!errors.codigoTransportista}
                    helperText={errors.codigoTransportista?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="areaPais"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Area de pais es obligatorio",
                  maxLength: {
                    value: 7,
                    message: "Máximo 7 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Area de pais"
                    fullWidth
                    error={!!errors.areaPais}
                    helperText={errors.areaPais?.message}
                    inputProps={{ maxLength: 7 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="dTransportista"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Direccion Transportista es obligatorio",
                  maxLength: {
                    value: 105,
                    message: "Máximo 105 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Direccion Transportista"
                    fullWidth
                    error={!!errors.dTransportista}
                    helperText={errors.dTransportista?.message}
                    inputProps={{ maxLength: 105 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="correo"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Correo Electronico es obligatorio",
                  maxLength: {
                    value: 26,
                    message: "Máximo 26 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Correo Electronico"
                    fullWidth
                    error={!!errors.correo}
                    helperText={errors.correo?.message}
                    inputProps={{ maxLength: 26 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="telefono"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Telefono es obligatorio",
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Telefonos"
                    fullWidth
                    error={!!errors.telefono}
                    helperText={errors.telefono?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Divider
              sx={{
                minWidth: { xs: "375px", sm: "100%", borderBottomWidth: "5px" },
              }}
              component="li"
            />
            <Grid item xs={12} md={4}>
              <Controller
                name="piloto"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Nombre del Conductor es obligatorio",
                  maxLength: {
                    value: 37,
                    message: "Máximo 37 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Nombre del Conductor"
                    fullWidth
                    error={!!errors.piloto}
                    helperText={errors.piloto?.message}
                    inputProps={{ maxLength: 37 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="nacionalidad"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Nacionalidad es obligatorio",
                  maxLength: {
                    value: 16,
                    message: "Máximo 16 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Nacionalidad"
                    fullWidth
                    error={!!errors.nacionalidad}
                    helperText={errors.nacionalidad?.message}
                    inputProps={{ maxLength: 16 }}
                  />
                )}
              />
            </Grid>
            <Divider
              sx={{
                minWidth: { xs: "375px", sm: "100%", borderBottomWidth: "5px" },
              }}
              component="li"
            />
            <Grid item xs={12} md={4}>
              <Controller
                name="licenciaPiloto"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Licencia de Conducir es obligatorio",
                  maxLength: {
                    value: 25,
                    message: "Máximo 25 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Licencia de Conducir No."
                    fullWidth
                    error={!!errors.licenciaPiloto}
                    helperText={errors.licenciaPiloto?.message}
                    inputProps={{ maxLength: 25 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="bnacionalidad"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Nacionalidad es obligatorio",
                  maxLength: {
                    value: 16,
                    message: "Máximo 16 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Nacionalidad"
                    fullWidth
                    error={!!errors.bnacionalidad}
                    helperText={errors.bnacionalidad?.message}
                    inputProps={{ maxLength: 16 }}
                  />
                )}
              />
            </Grid>
            <Divider
              sx={{
                minWidth: { xs: "375px", sm: "100%", borderBottomWidth: "5px" },
              }}
              component="li"
            />
            <Grid item xs={12} md={4}>
              <Controller
                name="pasaporteNo"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Pasaporte es obligatorio",
                  maxLength: {
                    value: 20,
                    message: "Máximo 20 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Pasaporte No."
                    fullWidth
                    error={!!errors.pasaporteNo}
                    helperText={errors.pasaporteNo?.message}
                    inputProps={{ maxLength: 20 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="cnacionalidad"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Nacionalidad es obligatorio",
                  maxLength: {
                    value: 16,
                    message: "Máximo 16 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Nacionalidad Documento"
                    fullWidth
                    error={!!errors.cnacionalidad}
                    helperText={errors.cnacionalidad?.message}
                    inputProps={{ maxLength: 16 }}
                  />
                )}
              />
            </Grid>
            <Divider
              sx={{
                minWidth: { xs: "375px", sm: "100%", borderBottomWidth: "5px" },
              }}
              component="li"
            />
            <Grid item xs={12} md={4}>
              <Controller
                name="cabezalPlaca"
                control={control}
                defaultValue=""
                rules={{
                  required: "La placa del cabezal es obligatoria",
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Placa Cabezal"
                    fullWidth
                    error={!!errors.cabezalPlaca}
                    helperText={errors.cabezalPlaca?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="numeroMotor"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Numero de Motor es obligatorio",
                  maxLength: {
                    value: 20,
                    message: "Máximo 20 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. de Motor"
                    fullWidth
                    error={!!errors.numeroMotor}
                    helperText={errors.numeroMotor?.message}
                    inputProps={{ maxLength: 20 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="numeroChasis"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Numero de chasis es obligatorio",
                  maxLength: {
                    value: 20,
                    message: "Máximo 20 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. de Chasis"
                    fullWidth
                    error={!!errors.numeroChasis}
                    helperText={errors.numeroChasis?.message}
                    inputProps={{ maxLength: 20 }}
                  />
                )}
              />
            </Grid>
            {/* EJes de cabezal */}
            <Grid item xs={12} md={4}>
              <Controller
                name="noEjes"
                control={control}
                defaultValue=""
                rules={{
                  required: "El No. Ejes es obligatorio",
                  maxLength: {
                    value: 5,
                    message: "Máximo 5 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. Ejes"
                    fullWidth
                    error={!!errors.noEjes}
                    helperText={errors.noEjes?.message}
                    inputProps={{ maxLength: 5 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="taraEquipo"
                control={control}
                defaultValue=""
                rules={{
                  required: "Tara en Kilos es obligatorio",
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Tara en kilos"
                    fullWidth
                    error={!!errors.taraEquipo}
                    helperText={errors.taraEquipo?.message}
                    inputProps={{ maxLength: 10 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="DMarca"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Marca es obligatorio",
                  maxLength: {
                    value: 20,
                    message: "Máximo 20 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Marca Cabezal"
                    fullWidth
                    error={!!errors.DMarca}
                    helperText={errors.DMarca?.message}
                    inputProps={{ maxLength: 20 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="ColorYDetalles"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Color y detalle es obligatorio",
                  maxLength: {
                    value: 30,
                    message: "Máximo 30 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Color y Detalles"
                    fullWidth
                    error={!!errors.ColorYDetalles}
                    helperText={errors.ColorYDetalles?.message}
                    inputProps={{ maxLength: 30 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="eNacionalidad"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Nacionalidad es obligatorio",
                  maxLength: {
                    value: 16,
                    message: "Máximo 16 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Nacionalidad"
                    fullWidth
                    error={!!errors.eNacionalidad}
                    helperText={errors.eNacionalidad?.message}
                    inputProps={{ maxLength: 16 }}
                  />
                )}
              />
            </Grid>
            <Divider
              sx={{
                minWidth: { xs: "375px", sm: "100%", borderBottomWidth: "5px" },
              }}
              component="li"
            />
            <Grid item xs={12} md={4}>
              <Controller
                name="furgonPlaca"
                control={control}
                defaultValue=""
                rules={{
                  required: "La placa del furgón es obligatoria",
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Placa Furgón"
                    fullWidth
                    error={!!errors.furgonPlaca}
                    helperText={errors.furgonPlaca?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            {/* ejes de furgon */}
            <Grid item xs={12} md={4}>
              <Controller
                name="Ejes"
                control={control}
                defaultValue=""
                rules={{
                  required: "El No. Ejes es obligatorio",
                  maxLength: {
                    value: 5,
                    message: "Máximo 5 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. Ejes"
                    fullWidth
                    error={!!errors.Ejes}
                    helperText={errors.Ejes?.message}
                    inputProps={{ maxLength: 5 }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="tara"
                control={control}
                defaultValue=""
                rules={{
                  required: "Tara es obligatorio",
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Tara en kilos"
                    fullWidth
                    error={!!errors.tara}
                    helperText={errors.tara?.message}
                    inputProps={{ maxLength: 10 }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="fmarca"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Marca es obligatorio",
                  maxLength: {
                    value: 20,
                    message: "Máximo 20 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Marca Furgon"
                    fullWidth
                    error={!!errors.fmarca}
                    helperText={errors.fmarca?.message}
                    inputProps={{ maxLength: 20 }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="colorDetalles"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Color y detalle es obligatorio",
                  maxLength: {
                    value: 30,
                    message: "Máximo 30 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Color y Detalles"
                    fullWidth
                    error={!!errors.colorDetalles}
                    helperText={errors.colorDetalles?.message}
                    inputProps={{ maxLength: 30 }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="dNacionalidad"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Nacionalidad es obligatorio",
                  maxLength: {
                    value: 16,
                    message: "Máximo 16 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Nacionalidad"
                    fullWidth
                    error={!!errors.dNacionalidad}
                    helperText={errors.dNacionalidad?.message}
                    inputProps={{ maxLength: 16 }}
                  />
                )}
              />
            </Grid>
            <Divider
              sx={{
                minWidth: { xs: "375px", sm: "100%", borderBottomWidth: "5px" },
              }}
              component="li"
            />

            <Grid item xs={12} md={4}>
              <Controller
                name="dimensiones"
                control={control}
                defaultValue=""
                rules={{
                  required: "Las Dimensiones son obligatorias",
                  maxLength: {
                    value: 20,
                    message: "Máximo 20 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Dimensiones"
                    fullWidth
                    error={!!errors.dimensiones}
                    helperText={errors.dimensiones?.message}
                    inputProps={{ maxLength: 20 }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="tipoCamino"
                control={control}
                defaultValue=""
                rules={{
                  required: "Tipo de camino es obligatorio",
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Tipo de camion"
                    fullWidth
                    error={!!errors.tipoCamino}
                    helperText={errors.tipoCamino?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}></Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="lugarExpedicion"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Lugar de expedición es obligatorio",
                  maxLength: {
                    value: 26,
                    message: "Máximo 26 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Lugar de expedición"
                    fullWidth
                    error={!!errors.lugarExpedicion}
                    helperText={errors.lugarExpedicion?.message}
                    inputProps={{ maxLength: 26 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="fechaExpedicion"
                control={control}
                defaultValue=""
                rules={{ required: "La fecha de expedición es obligatoria" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Fecha de Expedición"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.fechaExpedicion}
                    helperText={errors.fechaExpedicion?.message}
                    onChange={(e) => {
                      const value = e.target.value; 
                      field.onChange(value);
                      handleDateChange(value); 
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="exportador"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Exportador es obligatorio",
                  maxLength: {
                    value: 55,
                    message: "Máximo 55 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Exportador"
                    fullWidth
                    error={!!errors.exportador}
                    helperText={errors.exportador?.message}
                    inputProps={{ maxLength: 55 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="dexportador"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Direccion Exportador es obligatorio",
                  maxLength: {
                    value: 122,
                    message: "Máximo 122 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Direccion Exportador"
                    fullWidth
                    error={!!errors.dexportador}
                    helperText={errors.dexportador?.message}
                    inputProps={{ maxLength: 122 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="consignatario"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Consignacion es obligatorio",
                  maxLength: {
                    value: 47,
                    message: "Máximo 47 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Consignatario"
                    fullWidth
                    error={!!errors.consignatario}
                    helperText={errors.consignatario?.message}
                    inputProps={{ maxLength: 47 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="direccionConsignatario"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Direccion Consignatario es obligatorio",
                  maxLength: {
                    value: 112,
                    message: "Máximo 112 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Dirección Consignatario"
                    fullWidth
                    error={!!errors.direccionConsignatario}
                    helperText={errors.direccionConsignatario?.message}
                    inputProps={{ maxLength: 112 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="paisOrigen"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Pais Origen es obligatorio",
                  maxLength: {
                    value: 15,
                    message: "Máximo 15 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="País Origen"
                    fullWidth
                    error={!!errors.paisOrigen}
                    helperText={errors.paisOrigen?.message}
                    inputProps={{ maxLength: 15 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="paisDestino"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Pais Destino es obligatorio",
                  maxLength: {
                    value: 15,
                    message: "Máximo 15 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="País Destino"
                    fullWidth
                    error={!!errors.paisDestino}
                    helperText={errors.paisDestino?.message}
                    inputProps={{ maxLength: 15 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="aduanaSalida"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Aduana Salida es obligatorio",
                  maxLength: {
                    value: 20,
                    message: "Máximo 20 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Aduana Salida"
                    fullWidth
                    error={!!errors.aduanaSalida}
                    helperText={errors.aduanaSalida?.message}
                    inputProps={{ maxLength: 20 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="Items"
                control={control}
                defaultValue=""
                rules={{
                  required: "El No. de Items es obligatorio",
                  maxLength: {
                    value: 6,
                    message: "Máximo 6 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. de Items"
                    fullWidth
                    error={!!errors.Items}
                    helperText={errors.Items?.message}
                    inputProps={{ maxLength: 6 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="cBultos"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Cantidad es obligatorio",
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Cantidad de Bultos"
                    fullWidth
                    error={!!errors.cBultos}
                    helperText={errors.cBultos?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="aduanaDestino"
                control={control}
                defaultValue=""
                rules={{
                  required: "La Aduana Destino es obligatorio",
                  maxLength: {
                    value: 20,
                    message: "Máximo 20 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Aduana Destino"
                    fullWidth
                    error={!!errors.aduanaDestino}
                    helperText={errors.aduanaDestino?.message}
                    inputProps={{ maxLength: 20 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorTotal"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Valor total es obligatorio",
                  maxLength: {
                    value: 15,
                    message: "Máximo 15 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor total"
                    fullWidth
                    error={!!errors.valorTotal}
                    helperText={errors.valorTotal?.message}
                    inputProps={{ maxLength: 15 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNetoTotal"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Peso Neto total es obligatorio",
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto total"
                    fullWidth
                    error={!!errors.pesoNetoTotal}
                    helperText={errors.pesoNetoTotal?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="flete"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Valor Flete es obligatorio",
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor Flete"
                    fullWidth
                    error={!!errors.flete}
                    helperText={errors.flete?.message}
                    inputProps={{ maxLength: 12 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="nCartaPorte"
                control={control}
                defaultValue=""
                rules={{
                  required: "El No. Carta Porte es obligatorio",
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. Carta Porte"
                    fullWidth
                    error={!!errors.nCartaPorte}
                    helperText={errors.nCartaPorte?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBrutoTotal"
                control={control}
                defaultValue=""
                rules={{
                  required: "El peso Bruto total es obligatorio",
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto total"
                    fullWidth
                    error={!!errors.pesoBrutoTotal}
                    helperText={errors.pesoBrutoTotal?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="seguro"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Valor Seguro es obligatorio",
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor Seguro"
                    fullWidth
                    error={!!errors.seguro}
                    helperText={errors.seguro?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="nManifiesto"
                control={control}
                defaultValue=""
                rules={{
                  required: "El No. Manifiesto es obligatorio",
                  maxLength: {
                    value: 5,
                    message: "Máximo 5 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. Manifiesto"
                    fullWidth
                    error={!!errors.nManifiesto}
                    helperText={errors.nManifiesto?.message}
                    inputProps={{ maxLength: 5 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="incoterms"
                control={control}
                defaultValue=""
                rules={{
                  required: "El Incoterms es obligatorio",
                  maxLength: {
                    value: 6,
                    message: "Máximo 6 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Incoterms"
                    fullWidth
                    error={!!errors.incoterms}
                    helperText={errors.incoterms?.message}
                    inputProps={{ maxLength: 6 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="otrosGastos"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Otros Gastos"
                    fullWidth
                    error={!!errors.otrosGastos}
                    helperText={errors.otrosGastos?.message}
                    inputProps={{ maxLength: 12 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="observaciones"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 140,
                    message: "Máximo 140 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="observaciones"
                    fullWidth
                    error={!!errors.observaciones}
                    helperText={errors.observaciones?.message}
                    inputProps={{ maxLength: 140 }}
                  />
                )}
              />
            </Grid>

            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 1
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura}
                    helperText={errors.factura?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto}
                    helperText={errors.NoBulto?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos}
                    helperText={errors.claseBultos?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto}
                    helperText={errors.conteProducto?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria}
                    helperText={errors.arancelaria?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia}
                    helperText={errors.valorMercaderia?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto}
                    helperText={errors.pesoNeto?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto}
                    helperText={errors.pesoBruto?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 2
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura2"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura2}
                    helperText={errors.factura2?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto2"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto2}
                    helperText={errors.NoBulto2?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos2"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos2}
                    helperText={errors.claseBultos2?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto2"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto2}
                    helperText={errors.conteProducto2?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria2"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria2}
                    helperText={errors.arancelaria2?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia2"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia2}
                    helperText={errors.valorMercaderia2?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto2"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto2}
                    helperText={errors.pesoNeto2?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto2"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto2}
                    helperText={errors.pesoBruto2?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 3
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura3"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura3}
                    helperText={errors.factura3?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto3"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto3}
                    helperText={errors.NoBulto3?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos3"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos3}
                    helperText={errors.claseBultos3?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto3"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto3}
                    helperText={errors.conteProducto3?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria3"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria3}
                    helperText={errors.arancelaria3?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia3"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia3}
                    helperText={errors.valorMercaderia3?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto3"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto3}
                    helperText={errors.pesoNeto3?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto3"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto3}
                    helperText={errors.pesoBruto3?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 4
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura4"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura4}
                    helperText={errors.factura4?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto4"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto4}
                    helperText={errors.NoBulto4?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos4"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos4}
                    helperText={errors.claseBultos4?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto4"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto4}
                    helperText={errors.conteProducto4?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria4"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria4}
                    helperText={errors.arancelaria4?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia4"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia4}
                    helperText={errors.valorMercaderia4?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto4"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto4}
                    helperText={errors.pesoNeto4?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto4"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto4}
                    helperText={errors.pesoBruto4?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 5
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura5"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura5}
                    helperText={errors.factura5?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto5"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto5}
                    helperText={errors.NoBulto5?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos5"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos5}
                    helperText={errors.claseBultos5?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto5"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto5}
                    helperText={errors.conteProducto5?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria5"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria5}
                    helperText={errors.arancelaria5?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia5"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia5}
                    helperText={errors.valorMercaderia5?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto5"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto5}
                    helperText={errors.pesoNeto5?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto5"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto5}
                    helperText={errors.pesoBruto5?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 6
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura6"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura6}
                    helperText={errors.factura6?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto6"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto6}
                    helperText={errors.NoBulto6?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos6"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos6}
                    helperText={errors.claseBultos6?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto6"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto6}
                    helperText={errors.conteProducto6?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria6"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria6}
                    helperText={errors.arancelaria6?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia6"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia6}
                    helperText={errors.valorMercaderia6?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto6"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto6}
                    helperText={errors.pesoNeto6?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto6"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto6}
                    helperText={errors.pesoBruto6?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 7
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura7"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura7}
                    helperText={errors.factura7?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto7"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto7}
                    helperText={errors.NoBulto7?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos7"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos7}
                    helperText={errors.claseBultos7?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto7"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto7}
                    helperText={errors.conteProducto7?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria7"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria7}
                    helperText={errors.arancelaria7?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia7"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia7}
                    helperText={errors.valorMercaderia7?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto7"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto7}
                    helperText={errors.pesoNeto7?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto7"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto7}
                    helperText={errors.pesoBruto7?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 8
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura8"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura8}
                    helperText={errors.factura8?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto8"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto8}
                    helperText={errors.NoBulto8?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos8"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos8}
                    helperText={errors.claseBultos8?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto8"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto8}
                    helperText={errors.conteProducto8?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria8"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria8}
                    helperText={errors.arancelaria8?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia8"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia8}
                    helperText={errors.valorMercaderia8?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto8"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto8}
                    helperText={errors.pesoNeto8?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto8"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto8}
                    helperText={errors.pesoBruto8?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                marginTop: 4,
                marginLeft: 4,
                width: { xs: "auto", sm: "100%" },
              }}
            >
              FACTURA 9
            </Typography>
            <Grid item xs={12} md={4}>
              <Controller
                name="factura9"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Factura"
                    fullWidth
                    error={!!errors.factura9}
                    helperText={errors.factura9?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="NoBulto9"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 8,
                    message: "Máximo 8 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="No. De Bultos"
                    fullWidth
                    error={!!errors.NoBulto9}
                    helperText={errors.NoBulto9?.message}
                    inputProps={{ maxLength: 8 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="claseBultos9"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Clases de Bultos"
                    fullWidth
                    error={!!errors.claseBultos9}
                    helperText={errors.claseBultos9?.message}
                  >
                    {claseBultosOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="conteProducto9"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 35,
                    message: "Máximo 35 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Contenido/Producto"
                    fullWidth
                    error={!!errors.conteProducto9}
                    helperText={errors.conteProducto9?.message}
                    inputProps={{ maxLength: 35 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="arancelaria9"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 18,
                    message: "Máximo 18 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Partida Arancelaria"
                    fullWidth
                    error={!!errors.arancelaria9}
                    helperText={errors.arancelaria9?.message}
                    inputProps={{ maxLength: 18 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="valorMercaderia9"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Valor"
                    fullWidth
                    error={!!errors.valorMercaderia9}
                    helperText={errors.valorMercaderia9?.message}
                    inputProps={{ maxLength: 10 }}
                    value={
                      field.value.startsWith("$")
                        ? field.value
                        : `$ ${field.value}`
                    } // Asegura que siempre tenga el $
                    onChange={(e) =>
                      field.onChange(
                        `$ ${e.target.value.replace(/^[$\s]+/, "")}`
                      )
                    } // Evita múltiples $
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoNeto9"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Neto Kg."
                    fullWidth
                    error={!!errors.pesoNeto9}
                    helperText={errors.pesoNeto9?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="pesoBruto9"
                control={control}
                defaultValue=""
                rules={{
                  maxLength: {
                    value: 12,
                    message: "Máximo 12 caracteres permitidos",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Peso Bruto Kg."
                    fullWidth
                    error={!!errors.pesoBruto9}
                    helperText={errors.pesoBruto9?.message}
                    inputProps={{ maxLength: 12 }}
                  />
                )}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 1, sm: 2 },
              }}
            >
              <Button
                variant="contained"
                style={{ backgroundColor: "#0c6efe", color: "#fff" }}
                onClick={handleSubmit(handlePrintInkjet)}
              >
                Carta de Porte
              </Button>

              <Button
                variant="contained"
                style={{ backgroundColor: "#0c6efe", color: "#fff" }}
                onClick={handleSubmit(handlePrintManifest)}
              >
                Manifiesto de Carga
              </Button>

              <Button
                variant="contained"
                style={{ backgroundColor: "#0c6efe", color: "#fff" }}
                onClick={handleSubmit(handlePrintGuide)}
              >
                Simulacion Guia de Transito
              </Button>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleSubmit(handleSendAllAsPdf)}
              >
                Enviar Documentos a Correo
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default ElaboracionTransito;
